import instance from "../root.api";
export const loginRequest = ({ identifier, password }) =>
  instance.post(`/auth/local`, { identifier, password });
export const registerRequest = (payload) =>
  instance.post(`/auth/local/register`, payload);
